import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import MainMenu from '~/scenes/header/main-menu'
import Logo from './logo'
import ProfileMenu from './profile-menu'
import IconWithCount from './icon-with-count'
import HeaderAction from './header-action'
import Phone from './phone'
import SearchBox from '../search-box'

const FloatingHeaderElements = props => {
  const {
    isLoggedIn,
    categorySuggestions,
    showSearchbox,
    isSearchPage,
    favouritesCount,
    unreadMessageCount,
    coursesCount,
    avatar,
    teachPath,
    isRecruitmentPage,
    profileMenuItems,
    loginPath,
    signupPath,
    profilePath,
    favouritesPath,
    inboxPath,
    firstName,
    visiblerule,
    auxAvatar,
    headerFavouritesCount,
    searchedQuery,
    performSearch,
    enableFavoritesPage
  } = props

  // From the props or from a reducer if manually updated
  const totalFavouritesCount = !headerFavouritesCount ? favouritesCount : headerFavouritesCount

  const buttonTitle =
    isLoggedIn && coursesCount > 0 ? I18n.t('layouts.application.my_classes') : I18n.t('layouts.application.teach_long')

  return (
    <div className={`react-header min-react-header${visiblerule ? ` ${visiblerule}` : ''}`}>
      <MainMenu
        isLoggedIn={isLoggedIn}
        coursesCount={coursesCount}
        avatar={auxAvatar || avatar}
        loginPath={loginPath}
        signupPath={signupPath}
        profilePath={profilePath}
        firstName={firstName}
        mainMenuId='floating-header-main-menu'
      />
      <Logo onlyMin isLoggedIn={isLoggedIn} showSearchbox={showSearchbox} />
      {!isRecruitmentPage && (
        <SearchBox
          searchedQuery={searchedQuery}
          performSearch={performSearch}
          alwaysDisplayed
          categorySuggestions={categorySuggestions}
        />
      )}
      {isLoggedIn ? (
        <div className='right-elements'>
          <HeaderAction isButton hideUnder={640} redirectUrl={teachPath} title={buttonTitle} />
          <ProfileMenu avatar={avatar} menuItems={profileMenuItems.filter(item => !!item)} />
          <IconWithCount object='notifications' count={unreadMessageCount} redirectLink={inboxPath} />
          <IconWithCount
            object='favorites'
            count={totalFavouritesCount}
            redirectLink={isSearchPage ? null : favouritesPath}
            onClick={isSearchPage ? enableFavoritesPage : null}
          />
        </div>
      ) : (
        <div className='right-elements'>
          <HeaderAction
            isButton
            hideUnder={isRecruitmentPage ? 320 : 640}
            isCentered={false}
            redirectUrl={teachPath}
            title={buttonTitle}
          />
          {totalFavouritesCount > 0 && (
            <IconWithCount
              object='favorites'
              count={totalFavouritesCount}
              redirectLink={isSearchPage ? null : favouritesPath}
              onClick={isSearchPage ? enableFavoritesPage : null}
            />
          )}
          <Phone lastOnRight={showSearchbox} />
        </div>
      )}
    </div>
  )
}

FloatingHeaderElements.propTypes = {
  isLoggedIn: PropTypes.bool,
  categorySuggestions: PropTypes.array,
  showSearchbox: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  favouritesCount: PropTypes.number,
  unreadMessageCount: PropTypes.number,
  coursesCount: PropTypes.number,
  avatar: PropTypes.string,
  teachPath: PropTypes.string,
  isRecruitmentPage: PropTypes.bool,
  loginPath: PropTypes.string,
  signupPath: PropTypes.string,
  profilePath: PropTypes.string,
  inboxPath: PropTypes.string,
  firstName: PropTypes.string,
  favouritesPath: PropTypes.string,
  visiblerule: PropTypes.string,
  auxAvatar: PropTypes.string,
  profileMenuItems: PropTypes.array,
  headerFavouritesCount: PropTypes.number,
  searchedQuery: PropTypes.string,
  performSearch: PropTypes.func,
  enableFavoritesPage: PropTypes.func
}

export default FloatingHeaderElements
